import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { KpiGridBlock } from '@core/services/ai/ai-assistant.service';

@Component({
  selector: 'app-ai-kpi-grid-block',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    @if (block.title) {
      <div class="kpi-title">{{ block.title }}</div>
    }
    <div class="kpi-grid">
      @for (item of block.items; track item.label) {
        <div class="kpi-card" [attr.data-tone]="item.tone || 'neutral'">
          @if (item.icon) {
            <mat-icon class="kpi-icon">{{ item.icon }}</mat-icon>
          }
          <div class="kpi-body">
            <div class="kpi-value">{{ item.value }}</div>
            <div class="kpi-label">{{ item.label }}</div>
            @if (item.hint) {
              <div class="kpi-hint">{{ item.hint }}</div>
            }
          </div>
        </div>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .kpi-title {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: rgba(15, 23, 42, 0.55);
        margin: 0 0 8px;
      }
      .kpi-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
        gap: 8px;
      }
      .kpi-card {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px 14px;
        border-radius: 12px;
        background: #fff;
        border: 1px solid rgba(15, 23, 42, 0.08);
        border-left: 3px solid #6366f1;
      }
      .kpi-card[data-tone='positive'] {
        border-left-color: #10b981;
      }
      .kpi-card[data-tone='warning'] {
        border-left-color: #f59e0b;
      }
      .kpi-card[data-tone='danger'] {
        border-left-color: #ef4444;
      }
      .kpi-icon {
        font-size: 22px;
        width: 22px;
        height: 22px;
        color: #6366f1;
        flex-shrink: 0;
      }
      .kpi-card[data-tone='positive'] .kpi-icon {
        color: #10b981;
      }
      .kpi-card[data-tone='warning'] .kpi-icon {
        color: #f59e0b;
      }
      .kpi-card[data-tone='danger'] .kpi-icon {
        color: #ef4444;
      }
      .kpi-body {
        min-width: 0;
        flex: 1;
      }
      .kpi-value {
        font-size: 20px;
        font-weight: 700;
        line-height: 1.1;
        color: rgba(15, 23, 42, 0.92);
        overflow-wrap: anywhere;
        word-break: break-word;
      }
      .kpi-label {
        font-size: 12px;
        color: rgba(15, 23, 42, 0.6);
        margin-top: 2px;
        overflow-wrap: anywhere;
      }
      .kpi-hint {
        font-size: 11px;
        color: rgba(15, 23, 42, 0.5);
        margin-top: 2px;
        overflow-wrap: anywhere;
      }
    `
  ]
})
export class AiKpiGridBlockComponent {
  @Input({ required: true }) block!: KpiGridBlock;
}
